import { IDocumentEditable } from "..";
import { NumericFormatKinds, NumericInputFormatter } from "../../../../domain/document";
import { instanceOfIMoneyFormatable, IMoneyFormatable } from "../../../../domain/document/items";

export class MoneyFormatInitializer {
  constructor(public source: IDocumentEditable) {
  }
  
  initialize(isQuoting: boolean = false): void {
    for (let i = 0; i < this.source.itemSets.length; i++) {
      const items = this.source.itemSets[i].items
        .filter(instanceOfIMoneyFormatable);
      this.initializeMoneyFormatToItems(items, i, isQuoting);
    }
  }

  private initializeMoneyFormatToItems(items: IMoneyFormatable[], itemSetId: number, isQuoting: boolean): void {
    for (const item of items) {
      if (!item.isFreeInputable || !item.isNumeric || item.numericFormat !== NumericFormatKinds.Money) { continue; }
      const cloned = item.clone() as IMoneyFormatable;
      cloned.value = NumericInputFormatter.format(cloned.value, cloned.numericFormat);
      this.source.updateItem(cloned, {
        itemSetId,
        isQuoting,
      });
    }
  }
}
